<template>
  <v-container class="escala-medica">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <PageTitle
          main="Saúde"
          icon="mdi-pencil-box-outline"
          sub="Escalas médicas"
          home="/saude"
        />
        <input
          id="user-id"
          type="hidden"
          v-model="escala.usuario"
        />
        <input
          id="rgf-id"
          type="hidden"
          v-model="escala.id"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="codigo"
          >
            <v-checkbox
              v-model="escala.inativar"
              label="Inativar escala?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="5"
          >
            <v-text-field
              v-model="escala.titulo"
              label="Descrição"
              required
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-autocomplete
              v-model="escala.uid_categoria"
              :items="categorias"
              required
              dense
              outlined
              label="Lotação"
              @change="loadCartas"
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-autocomplete
              v-model="escala.uid_unidade"
              :items="cartas"
              required
              dense
              outlined
              label="Unidade de saúde"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="dtp"
                  v-model="data_pub"
                  label="Data de publicação.:"
                  dense
                  outlined
                  @blur="mudaData"
                >
                  <v-icon
                    slot="append"
                    color="success"
                    large
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="date"
                @input="dateB"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="2"
          >
            <v-text-field
              v-model="escala.ano_publicacao"
              label="Ano da publicação"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="2"
          >
            <v-text-field
              v-model="escala.ano_referencia"
              label="Ano de referência"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-checkbox
              v-model="escala.publicado"
              label="Publicar escala?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
          >
            <v-tab @click="loadAnexos">
              <v-icon class="mr-1">
                mdi-paperclip
              </v-icon>
              Anexos
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersAnexos"
                        :items="anexos"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadAnexo(item, 'edit')"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="AddAnexo"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add anexo
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-1">
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              :disabled="!valid"
              color="success"
              class="ml-1 mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="escalas"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadEscala(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon
                      medium
                      color="error"
                      class="mr-2"
                      @click="loadEscala(item, 'remove')"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="DialogAnexo"
          transition="dialog-top-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <div class="logo-foto ml-4 mt-5">
              <v-form
                v-model="valid"
                ref="form"
                class="altura"
              >
                <PageTitle
                  v-if="anexo.id"
                  icon="mdi-pencil-box-outline"
                  :sub="`Anexo (${anexo.nome})`"
                />
                <PageTitle
                  v-else
                  icon="mdi-pencil-box-outline"
                  sub="Adicionar anexo"
                />
                <input
                  id="user-id"
                  type="hidden"
                  v-model="anexo.usuario"
                />
                <input
                  id="anexo-id"
                  type="hidden"
                  v-model="anexo.id"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="7"
                    lg="8"
                  >
                    <v-text-field
                      v-model="anexo.nome"
                      type="text"
                      label="Nome do arquivo"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    lg="4"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datp"
                          v-model="date_pub"
                          label="Data de publicacao.:"
                          dense
                          outlined
                          @blur="mudaDataA"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date1"
                        @input="dateA"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="5"
                    lg="4"
                  >
                    <v-autocomplete
                      v-model="anexo.mes"
                      :items="dataMeses"
                      dense
                      outlined
                      label="Selecione o mês"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="mode === 'edit'">
                  <v-col cols="12" md="10" lg="10">
                    <v-text-field
                      v-if="!fileNovo"
                      :value="urlAnexo"
                      label="Arquivo atual"
                      outlined
                      dense
                      readonly
                      prepend-inner-icon="mdi-file"
                      hint="Arquivo atual anexado"
                      persistent-hint
                    >
                      <template v-slot:append>
                        <div class="botao-container">
                          <v-btn icon small @click="baixarArquivo()">
                            <v-icon>mdi-download</v-icon>
                          </v-btn>

                          <v-btn icon small @click="abrirInputTroca()">
                            <v-icon>mdi-file-replace</v-icon>
                          </v-btn>

                          <v-btn icon small color="red" @click="confirmRemove()">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-text-field>
                    <input
                      v-show="fileNovo"
                      type="file"
                      ref="fileTroca"
                      v-if="uploadReady"
                      dense
                      outlined
                      accept="application/pdf, application/vnd.ms-excel"
                      @change="handleTroca"
                    />
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12" md="6">
                    <v-file-input
                      label="Enviar anexo"
                      prepend-icon="mdi-file-upload"
                      dense
                      outlined
                      accept="application/pdf, application/vnd.ms-excel"
                      @change="handleUpload"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                class="mr-4"
                v-if="codigo && fileNovo"
                @click="clearUpload"
              >
                Remover
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="mode === 'novo' || fileNovo"
                type="submit"
                @click.prevent="fileUpload()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="mode === 'edit' && !fileNovo"
                @click="updateAnexo()"
              >
                <v-icon left>
                  mdi-update
                </v-icon>
                update
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
    <!-- Modal de confirmação -->
      <v-dialog v-model="dialogRmAnexo" max-width="400">
        <v-card>
          <v-card-title class="headline">
            Confirmar remoção
          </v-card-title>

          <v-card-text>
            Tem certeza de que deseja remover este anexo?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="grey" text @click="dialogRmAnexo = false">
              Cancelar
            </v-btn>

            <v-btn color="red" text @click="removeAnexoConfirmado">
              Remover
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
// import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'EscalaMedica',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    dtp: '##/##/####',
    datp: '##/##/####',
    tabs: null,
    codigo: '',
    dialog: false,
    DialogAnexo: false,
    loading: false,
    uploadReady: true,
    dialogRmAnexo: false,
    anexoSelecionado: null,
    anexoRemover: null,
    file: null,
    fileNovo: null,
    tabela: 'escalaanexos',
    pasta: 'escalas',
    urlAnexo: '',
    search: null,
    select: null,
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    data_pub: '',
    date_pub: '',
    menu: false,
    menu1: false,
    mode: 'save',
    escala: {},
    anexo: {},
    categorias: [],
    cartas: [],
    anexos: [],
    escalas: [],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'titulo' },
      { text: 'Ano de referência', value: 'ano_referencia' },
      { text: 'Publicação', value: 'data' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersAnexos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Tabela', value: 'tabela' },
      { text: 'Pasta', value: 'pasta' },
      { text: 'Mês', value: 'mes' },
      { text: 'Data', value: 'dtpub' },
      { text: 'Nome do arquivo', value: 'nome' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    dataMeses: [
      { value: 'JANEIRO', text: 'Janeiro' },
      { value: 'FEVEREIRO', text: 'Fevereiro' },
      { value: 'MARÇO', text: 'Março' },
      { value: 'ABRIL', text: 'Abril' },
      { value: 'MAIO', text: 'Maio' },
      { value: 'JUNHO', text: 'Junho' },
      { value: 'JULHO', text: 'Julho' },
      { value: 'AGOSTO', text: 'Agosto' },
      { value: 'SETEMBRO', text: 'Setembro' },
      { value: 'OUTUBRO', text: 'Outubro' },
      { value: 'NOVEMBRO', text: 'Novembro' },
      { value: 'DEZEMBRO', text: 'Derzembeo' }
    ],
    valid: false
  }),
  methods: {
    dateB () {
      this.data_pub = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
    },
    mudaData () {
      const [dia, mes, ano] = this.data_pub.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateA () {
      this.date_pub = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
    },
    mudaDataA () {
      const [dia, mes, ano] = this.date_pub.split('/')
      this.date1 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      this.anexo.data_publicacao = this.date1
    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      this.escala.publicacao = this.date
      //  this.escala.data_termino = this.date1
      const method = this.escala.id ? 'put' : 'post'
      const id = this.escala.id ? `/${this.escala.id}` : ''
      axios[method](`${baseApiUrl}/escala-medica${id}`, this.escala)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    baixarArquivo () {
      window.open(this.urlAnexo, '_blank')
    },
    abrirInputTroca () {
      this.$refs.fileTroca.click()
    },
    handleTroca (e) {
      const file = e.target.files[0]
      if (file) {
        // this.mode = 'save'
        this.fileNovo = file
        this.file = file
        this.uploadReady = true
      }
    },
    handleUpload (file) {
      this.file = file
    },
    async fileUpload () {
      if (!this.file) {
        this.$toasted.global.defaultError('Selecione um arquivo')
        return
      }
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo${id}`
      formData.append('uid_escala', this.escala.id)
      formData.append('data_publicacao', this.date1)
      formData.append('mes', this.anexo.mes)
      formData.append('nome', this.anexo.nome)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.pasta)
      formData.append('subpasta', this.escala.id)
      formData.append('usuario', this.anexo.usuario)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    resetUpload () {
      this.file = null
      this.fileNovo = null
      this.anexo = {}
      if (this.$refs.fileTroca) this.$refs.fileTroca.value = null
    },
    clearUpload () {
      this.uploadReady = false
      this.file = null
      this.fileNovo = null
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    updateAnexo () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      this.anexo.tabela = this.tabela
      axios[method](`${baseApiUrl}/anexos-do-portal${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.FecharDialog()
          this.loadAnexos()
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    confirmRemove (item) {
      this.anexoSelecionado = item || this.anexo
      this.dialogRmAnexo = true
    },
    removeAnexoConfirmado () {
      const id = this.anexoRemover || this.anexoSelecionado.id
      this.anexo.tabela = this.anexoSelecionado.tabela
      const tabela = this.anexoSelecionado.tabela
      axios.delete(`${baseApiUrl}/upload-documentos-em-anexo/${id}`, {
        params: { tabela }
      })
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadAnexos()
        })
        .catch(showError)
        .finally(() => {
          this.dialogRmAnexo = false
          this.anexoSelecionado = null
          this.anexoRemover = null
        })
    },
    loadAnexos () {
      const id = this.escala.id
      const url = `${baseApiUrl}/anexos-da-escala/${id}`
      axios.get(url).then(res => {
        const anexos = res.data.map(item => {
          return {
            ...item,
            dtpub: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
        this.anexos = anexos
        this.$nextTick(() => {
          console.log('Atualizou anexos')
        })
      })
    },
    loadCategorias () {
      const url = `${baseApiUrl}/categorias`
      axios.get(url).then(res => {
        this.categorias = res.data.map(cat => {
          return {
            value: cat.id,
            text: cat.categoria
          }
        })
      })
    },
    loadCartas (item) {
      const id = item.uid_categoria || this.escala.uid_categoria
      const url = `${baseApiUrl}/carta-de-servicos-por-categoria/${id}`
      axios.get(url).then(res => {
        this.cartas = res.data.map(un => {
          return {
            value: un.id,
            text: `${un.titulo} -  ${un.id}`
          }
        })
      })
    },
    loadEscalas () {
      const url = `${baseApiUrl}/escala-medica-filtro`
      axios.get(url).then(res => {
        this.escalas = res.data.map(item => {
          return {
            ...item,
            data: moment(item.publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadEscala (item, mode = 'save') {
      this.mode = mode
      this.escala = { ...item }
      this.data_pub = moment(item.publicacao).format('DD/MM/YYYY')
      this.codigo = this.escala.id
      this.dialog = false
      this.valid = true
      this.loadCartas(item)
    },
    loadFile (anexo, mode = 'save') {
      this.mode = mode
      this.anexo = { ...anexo }
      this.anexo.usuario = this.user.id
      this.DialogAnexo = true
    },
    loadAnexo (anexo, mode = 'edit') {
      this.mode = mode
      this.anexo = { ...anexo }
      this.anexo.usuario = this.user.id
      this.urlAnexo = anexo.url
      this.date_pub = moment(anexo.data_publicacao).format('DD/MM/YYYY')
      this.DialogAnexo = true
      this.loadDtAnexo()
    },
    AddAnexo () {
      this.mode = 'novo'
      this.anexo.usuario = this.user.id
      this.anexo.uid_plano = this.escala.id
      this.DialogAnexo = true
    },
    reset () {
      this.$refs.form.reset()
      this.valid = true
      this.mode = 'save'
      this.escala = {}
    },
    limpar () {
      this.mode = 'save'
      this.urlAnexo = ''
      this.anexo = {}
      this.anexo.usuario = this.user.id
      this.anexo.uid_plano = this.escala.id
    },
    FecharDialog () {
      this.file = null
      this.fileNovo = null
      this.DialogAnexo = false
      this.limpar()
    },
    loadDialog () {
      this.dialog = true
      this.loadEscalas()
    },
    loadDatas () {
      this.mudaData()
    },
    loadDtAnexo () {
      this.mudaDataA()
      this.dateA()
    },
    loadUser () {
      this.escala.usuario = this.user.id
    }
  },
  mounted () {
    this.loadUser()
    this.loadCategorias()
  }
}
</script>

<style scoped>
.altura {
  min-height: 380px !important;
}
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}
.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 1024px;
}
.botao-container {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #e0f2f1;
  margin-top: -7px !important;
  margin-right: -9px !important;
  padding: 6px 6px;
  border-radius: 6px;
}
</style>
